import { z } from 'zod/v4';

// Mirrors the v2 send controllers' permitted_params; keys the backend does not
// permit are stripped before the POST.
const ReminderSendingOptionsSchema = z.object({
  templateId: z.string(),
  addLateFees: z.boolean(),
  sendEmail: z.boolean(),
  sendPost: z.boolean(),
  sendRegisteredPost: z.boolean(),
  emails: z.array(z.object({ value: z.string() })),
  addressesAttributes: z.array(
    z.object({
      id: z.string().optional(),
      additional_line_1: z.string().optional(),
      additional_line_2: z.string().optional(),
      street_name: z.string().optional(),
      street_number: z.string().optional(),
      street_box: z.string().optional(),
      zip_code: z.string().optional(),
      city: z.string().optional(),
      country_code: z.string().optional(),
    }),
  ),
});

export const SendReminderVariablesSchema = z.object({
  invoiceId: z.string(),
  additionalInvoiceIds: z.array(z.string()),
  creditNoteIds: z.array(z.string()),
  accountingPaymentIds: z.array(z.string()),
  tpPaymentIds: z.array(z.string()),
  sendingOptions: ReminderSendingOptionsSchema,
});

export type SendReminderVariables = z.infer<typeof SendReminderVariablesSchema>;
